export default (indicatorValue, accountUUID) => {
    let newValue = indicatorValue.split(', ');
    let clientUUIDindex = newValue.indexOf('ClientUUID');
    newValue[clientUUIDindex] = accountUUID;
    return newValue.join(', ')
}